import { Controller } from '@hotwired/stimulus'
import { Offcanvas } from 'bootstrap'

// Opens the backup-history side panel for a single resource. The clicked element's
// href points at the per-resource history endpoint; we load it into the offcanvas's
// turbo-frame and reveal the panel. Wired from the React dynamic-table "History" column,
// so the controller lives on the rendered anchor itself.
export default class extends Controller {
  open(event) {
    event.preventDefault()

    const url = this.element.getAttribute('href')
    const frame = document.getElementById('backup-history-detail-frame')
    const panel = document.getElementById('backup-history-offcanvas')
    if (!url || !frame || !panel) return

    if (frame.getAttribute('src') !== url) {
      frame.setAttribute('src', url)
    }

    // backdrop/scroll options live on the panel as data-bs-* attributes so they
    // survive a Turbo back/forward re-hydrate (see turbo/offcanvas_restore.js).
    Offcanvas.getOrCreateInstance(panel).show()
  }
}
